async function trackProductView(productId) {
    if (!productId) return null;
    try {
        const response = await fetch('/wp-json/fgt/analytics/product-views', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ product_id: productId }),
            credentials: 'same-origin',
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (e) {
        return null;
    }
}

function updateProductViewsUI(text) {
    const block = document.getElementById('fgt-product-views-block');
    const el = document.getElementById('fgt-product-views');
    if (el && typeof text === 'string' && text.length > 0) {
        el.textContent = text;
        if (block) block.classList.remove('hidden');
    }
}

function updateProductOrdersUI(text) {
    const block = document.getElementById('fgt-product-orders-block');
    const el = document.getElementById('fgt-product-orders');
    if (el && typeof text === 'string' && text.length > 0) {
        el.textContent = text;
        if (block) block.classList.remove('hidden');
    }
}

export async function initTrackProductView() {
    const el = document.getElementById('fgt-product-views');
    if (!el) return;
    const productId = el.closest('[data-product-id]')?.getAttribute('data-product-id');
    if (!productId) return;
    const data = await trackProductView(productId);
    if (data) {
        if (data.views > 0) {
            updateProductViewsUI(data.views_text);
        }
        if (data.orders > 0) {
            updateProductOrdersUI(data.orders_text);
        }
    }
}
